'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extend = require('@souche-f2e/extend');

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultOptions = {
    userPhone: '',
    userId: '',
    url: '',
    siteId: 'others'
}; /*
    * @desc 使用piwik 统计PVUV
    */


var serverUrl = {
    development: 'http://datacenter-log-center.dasouche-inc.net/',
    prepub: 'http://traffic-v1.prepub.souche.com/',
    production: 'https://traffic-v1.souche.com/'
}[process.env.NODE_ENV] || 'https://traffic-v1.souche.com/';

var loadPiwikJs = function loadPiwikJs(params, router) {
    window._paq = window._paq || [];
    var _paq = window._paq;
    _paq.push(['setCustomVariable', 1, 'user_phone', params.userPhone]);
    _paq.push(['setCustomVariable', 2, 'user_id', params.userId]);
    _paq.push(['setCustomVariable', 3, 'site_tag', params.siteId]);
    _paq.push(['enableLinkTracking']);
    _paq.push(['setTrackerUrl', serverUrl + 'api/logApi/report.json']);

    // 创建script标签
    var d = document;
    var g = d.createElement('script');
    var s = d.getElementsByTagName('script')[0];

    g.type = 'text/javascript';
    g.async = true;
    g.defer = true;
    g.src = '//assets.souche.com/shop/lib/piwik.js';
    s.parentNode.insertBefore(g, s);

    if (!router) {
        return;
    }

    router.beforeEach(function (from, to, next) {
        window._paq.push(['setReferrerUrl', location.href]);
        setTimeout(function () {
            next();
        }, 0);
    });
    router.afterEach(function () {
        setTimeout(function () {
            window._paq.push(['setCustomUrl', location.href]);
            window._paq.push(['trackPageView']);
        }, 0);
    });
};

exports.default = {
    init: function init(params, router) {
        if (!params) {
            return;
        }
        params = (0, _extend2.default)(defaultOptions, params);
        loadPiwikJs(params, router);
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/statistics/dist/piwik/index.js
// module id = KJjQ
// module chunks = 11